import { Component, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GenericModule } from 'src/app/generic/generic.module';

@Component({
    selector: 'app-realisation-row-counts-total',
    imports: [GenericModule, MatTooltipModule],
    templateUrl: './realisation-row-counts-total.component.html',
    styleUrl: './realisation-row-counts-total.component.scss',
})
export class RealisationRowCountsTotalComponent {
    readonly userId = input<number>();
    readonly userRegisteredMinutes = input.required<number>();
    readonly entityRegisteredMinutes = input.required<number>();

    get hasTooManyRegisteredMinutes(): boolean {
        return !!this.userId() && this.userRegisteredMinutes() > 720;
    }
}
